/*
 * @Description: 优惠券
 * @Author: ywj
 * @Date: 2025-03-20 15:53:50
 * @LastEditTime: 2025-04-21 15:10:52
 * @LastEditors: ywj@originqc.com
 */
import React, { useState,useEffect } from "react";
import CopuonCard from './components/card'
import ChildHead from '../components/childHead'
import codeIcon from './imgs/code.png'
import CodeModal from './components/code-modal'
import { couponList,exchangeCode} from '@/api/coupon'
import { message } from 'antd'
import NoData from '@/components/no-data'

import './index.scss'

const Coupon: React.FC = () => {
  const [showCodeModal, setShowCodeModal] = useState<boolean>(false);
  const [couponData, setCouponData] = useState<any>([]);
  const [codeVal, setCodeVal] = useState('');
  const [codeTips, setCodeTips] = useState('');
  
  useEffect(() => { 
    handleCouponList();
  },[])
  const handleCouponList = () => { 
    couponList({}).then((res:any) => {
      if (res.success) {
        setCouponData(res?.obj??[]);
      } else { 
        message.error(res.message);
      }
    })
  }
  // 点击兑换码
  const handlechargeCode = () => {
    setShowCodeModal(true);
  }

  const handleOk = () => { 
    // TODO 接口传递兑换码
    if (codeVal) {
      exchangeCode({couponCode:codeVal}).then((res:any) => {
        if(res.success){
          message.success('兑换成功');
          setShowCodeModal(false);
          handleCouponList();
        }else{
          // message.error('券码验证错误，请重新操作')
          setCodeTips(res.message);
        }
      })
    }else{
      message.error('请先输入优惠券券码')
    }
  }
  return <div>
    <div className="coupon-container">
      <ChildHead
        title='优惠券'
        // subtitle='每个账号每种发票类型有效开票资质仅保存一个'
        rightText={`<div style='color:rgba(237, 112, 55, 1)'><img src=${codeIcon} alt='兑换码' style='margin-right:5px;margin-top:-3px'/>兑换码</div>`}
        callback={handlechargeCode}
      // disableHandleBtn={invoiceData.length >= 10}
      />
      {couponData.length > 0 ? <div className="card-content">
        {couponData.map((item: any) => {
          return <CopuonCard
            key={item.id}
            {...item}
            useStatus={item.useStatus}
            handleCouponList={handleCouponList}
          />
        })}
  
      </div> :<NoData/>}
    </div>
    <CodeModal
      showCodeModal={showCodeModal}
      setShowCodeModal={setShowCodeModal}
      handleOk={handleOk}
      setCodeVal={setCodeVal}
      codeTips={codeTips}
      setCodeTips={ setCodeTips}
    />
    
  </div>;
}

export default Coupon;
